/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Slovak
export default {
	'fabric.reactions.error.unexpected': 'Niečo sa nepodarilo',
	'fabric.reactions.loading': 'Načítava sa...',
};
